import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Department {
  id: string
  name: string
  branch_id?: string
}

export interface UseDepartmentsResult {
  departments: Department[]
  loading: boolean
  error: string | null
  refetch: (branchId?: string) => Promise<void>
}

export function useDepartments(branchId?: string): UseDepartmentsResult {
  const [departments, setDepartments] = useState<Department[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (currentBranchId?: string): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const url = currentBranchId ? `/departments/dropdown?branch_id=${currentBranchId}` : '/departments/dropdown'
      console.log('Fetching departments from:', url)
      const res = await api.get<{ departments: Department[] }>(url)
      console.log('Departments response:', res)
      setDepartments(res.departments || [])
    } catch (e) {
      console.error('Failed to fetch departments:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch departments')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refetch(branchId)
  }, [branchId, refetch])

  return { departments, loading, error, refetch }
}
